import 'core-js/features/promise';
import 'core-js/es/map';

import './css/AkWealthDistributionStory.scss';

import Preload from "image-preload";
import StoryFramework from 'storyframework-ts';

import arrowBubble from './img/arrow-bubble.svg';
import cloud1SVG from './img/cloud-1.svg';
import cloud1PNG from './img/cloud-1.png';
import cloud2PNG from './img/cloud-2.png';
import comicArrow from './img/comic-arrow.svg';
import akLogoTransp from './img/ak-logo-transp.svg';
import noise from './img/noise.png';

import WEALTH_DATA from './data/wealth.csv';

// import StoryFramework from 'storyframework-ts/src/StoryFramework.ts';

const BEATS = {
    INTRO: 'INTRO',
    BEAT_2: 'BEAT_2',
    BEAT_3: 'BEAT_3',
    BEAT_4: 'BEAT_4',
    BEAT_5: 'BEAT_5',
    BEAT_6: 'BEAT_6',
    BEAT_7: 'BEAT_7',
    BEAT_8: 'BEAT_8',
    BEAT_9: 'BEAT_9',
    BEAT_10: 'BEAT_10',
    BEAT_11: 'BEAT_11',
    BEAT_12: 'BEAT_12',
    BEAT_13: 'BEAT_13',
    BEAT_14: 'BEAT_14',
    BEAT_15: 'BEAT_15',
    CALCULATOR: 'CALCULATOR',
};

export default class AkWealthDistributionStory extends StoryFramework {
    sceneHeightRelative: number;
    beatTextTimeoutId: number|null;
    viewportMultiply: number;
    storyStarted: boolean;
    beat2TransformOriginX: number;
    zoom: number;
    bboxCache: Object;
    version: number;
    markers: Object;
    mariaThomasTimeoutId: number;
    beatTextTimeoutId: number;
    showAngelikaTimeoutId: number;
    averageIncome: number;

    constructor(holderSelector = '.interactive-content') {

        super('AKWD', 'trackingid', `https://${window.location.host}/`, holderSelector, {
            controls: {
                clickThroughIconOverlay: true
            },
            story: {
                timePerBeat: 6000
            },
            endStory: {
                scrollToContent: false,
                showScrollDownCursor: true
            }
        });

        this.extendJqueryEasings();

        this.viewportMultiply = 4;
        this.sceneHeightRelative = this.viewportMultiply * 100;



        this.beatTextTimeoutId = null;
        this.debug = false;
        this.storyStarted = false;

        // Start with controls disabled so you cannot interrupt intro animation.
        this.controlsDisabled = true;



        this.zoom = 1;
        this.beat2TransformOriginX = 50;

        this.bboxCache = {};
        this.version = 36;
        this.markers = {};

        // This must be calculated before the beats are defined.
        this.averageIncome = this.calculateAverageIncome();


        // This must come at the end.
        this.defineBeats();
    }

    calculateAverageIncome(): number {
        return 83000;
    }

    init() {
        let imgLoadComplete = false;
        let mintimerComplete = false;

        super.init();

        const now = Date.now();
        Preload([
            `${this.assetLocation}/img/fence.png`,
            `${this.assetLocation}/img/mountains.png`,

            `${this.assetLocation}/img/maria-thomas.jpg`,

            `${this.assetLocation}/img/angelika.jpg`,
            `${this.assetLocation}/img/buildings-left.png`,
            `${this.assetLocation}/img/buildings-left-2.png`,
            `${this.assetLocation}/img/buildings-right.png`,
            `${this.assetLocation}/img/buildings-right-2.png`,

            `${this.assetLocation}/img/dc-tower-r1.png`,
            `${this.assetLocation}/img/dc-tower-r2.png`,
            `${this.assetLocation}/img/dc-tower-top.png`
        ], {
            onComplete: () => {
                const then = Date.now();
                console.log('Image loading complete', then - now);
                this.layoutCityStructure();
                this.generateBgClouds();

                imgLoadComplete = true;

                if (mintimerComplete === true) {
                    this.startStory();
                }
            }
        });

        // Give the app some time to init before starting it.
        // Feels more natural.
        setTimeout(() => {
            mintimerComplete = true;

            if (imgLoadComplete === true) {
                this.startStory();
            }
        }, 2500);
    }

    /** @override */
    bindEvents() {
        super.bindEvents();

        this.find('calculate-btn').on('click', () => {
            let formattedAmount = <string>this.find('input').val();

            console.log('formatted', formattedAmount);

            if (formattedAmount === '')  {
                formattedAmount = '100000';
            };

            console.log('formatted', formattedAmount);

            // Remove all . as they are separators in German.
            formattedAmount = formattedAmount.replace(/\./g, '').replace(',', '.');

            console.log('formatted', formattedAmount);
            const amount = Number(formattedAmount);

            const percentile = 100 - this.getPercentileForWealth(amount); // invert percentile because we start at the bottom.
            const text = this.createTextForInputtedWealth(amount);

            this.setBeatText(text, 0);

            const startTop = <number>this.find('dc-tower-top').height() / <number>this.find('scene').height();
            const y = startTop + percentile;

            this.setCamera({
                duration: 2000,
                y: y,
                zoom: 0.6
            });

            // Animate the border.
            this.setEstimatedWealthBorder(percentile);
        });

        this.find('input').keypress(event => {
            const keycode = (event.keyCode ? event.keyCode : event.which);

            if (keycode === 13) {
                this.find('calculate-btn').trigger('click');
            }
        });
    }

    getPercentileForWealth(wealth) {
        for (let i = 0; i < WEALTH_DATA.length; i++) {
            const row = WEALTH_DATA[i];

            if (wealth >= row.wealth_cut) {
                return row.percentile;
            }
        }

        return 1;
    }

    setEstimatedWealthBorder(percentile: number): void {
        this.find('estimated-wealth-holder').css({
            'width': '120%',
            'opacity': '1',
            'top': `${percentile}%`,
        }).addClass('show');

        this.find('estimated-wealth-text').html(`${percentile} Prozent sind reicher als Sie`);
    }

    createTextForInputtedWealth(wealth): string {
        const wealthDiffVsAvg = wealth - this.averageIncome;
        let word = 'über';

        if (wealthDiffVsAvg < 0) {
            word = 'unter';
        }

        let html = `Damit liegen Sie ${this.numberFormatter.default(Math.abs(wealthDiffVsAvg))} Euro ${word} dem mittleren Vermögen in Österreich. `;

        if (wealth > 1000000) {
            const simplifiedTaxAmount = this.numberFormatter.default((wealth - 1000000) * 0.01);
            const complexTaxAmount = this.numberFormatter.default(this.calculateComplexTaxBrackedAmount(wealth));

            html += `
                Eine Vermögenssteuer ab einer Million Euro Nettovermögen würde Sie treffen.
                Beim einfachen Tarif wären Ihre Abgaben ${simplifiedTaxAmount} Euro, beim vierstufigen Tarif wären es ${complexTaxAmount} Euro.
            `;
        } else {
            html += `Eine Vermögenssteuer ab einer Million Euro Nettovermögen würde Sie nicht treffen.`;
        }

        return html;
    }

    calculateComplexTaxBrackedAmount(income): number {
        let tax = 0;
        const mil = 1000000;
        const tenmil = 10 * mil;
        const hundrethmil = 100 * mil;
        const bil = 1000 * mil;

        const rates = [
            [1, mil, 0],
            [mil + 1, tenmil, 1],
            [tenmil + 1, hundrethmil, 2],
            [hundrethmil + 1, bil, 3],
            [bil + 1, Infinity, 4]
        ];

        const brackets = this.createTaxBrackets(income, rates);


        brackets.forEach(bracket => {
            const [amount, percentage] = bracket;
            tax = tax + amount * (percentage / 100);
        });

            // tax = Math.round(tax)
        console.log('TAAAX', tax);
        return tax
    }

    createTaxBrackets(amount, rates) {
        var brackets = []

        rates.forEach(rate => {
            const [min, max, percentage] = rate

            // Our value includes all of this bracket
            if (amount > max) {
                brackets.push([max - min + 1, percentage])
            }

          // Our value falls within this bracket
            if (amount >= min && amount <= max) {
                brackets.push([amount - min + 1, percentage])
            }
        })

        return brackets
    }

    startStory() {
        this.setCamera({
            y: 0,
            duration: 0,
            zoom: 1
        });

        // Adding markers so I can target them for zooming and placement.
        this.addMarkers();

        super.startStory();

        // Recalucalte bbox cache once the scene is visible.
        setTimeout(this.refreshMarkerBboxCache.bind(this), 250);

        setTimeout(() => {
            if (this.currentStoryBeatIndex === 0) { // Don't run the animation if the user already moved to the next beat.
                this.setCamera({
                    y: 100,
                    duration: 8000
                });
            }
        }, 2500);

        this.runIntroAnimationText();

        setTimeout(() => {
            this.enableControls();
            this.storyStarted = true;
        }, 1000);
    }

    runIntroAnimationText() {
        this.find('intro-title').animate({
            opacity: 1,
            left: 0,
            top: 0
        }, 2500, 'easeOutCubic');

        setTimeout(() => {
            this.find('intro-main-bg').animate({
                opacity: 1
            }, 450, 'easeOutCubic');
        }, 300);


        setTimeout(() => {
            this.find('intro-subtitle').animate({
                opacity: 1,
                left: 0,
                top: 0
            }, 2500, 'easeOutCubic');
        }, 350);
    }

    /** @overide */
    getAppSpecificHtml(projectPrefix) {
        const p = projectPrefix;
        const a = this.assetLocation;

        return `
            <div class="${p}-bg"></div>

            <img class="${p}-ak-logo" src="${akLogoTransp}"/>
            <div class="${p}-noise" style="background-image: url(${noise})"></div>

            <div class="${p}-input-holder">
                <input type="text" placeholder="100.000" class="${p}-input" />
                <button class="${p}-calculate-btn">Einschätzen</button>
            </div>

            <div class="${p}-taxation-bar">
                <span class="${p}-taxation-label"></div>
            </div>

            <div class="${p}-rich-percentile-mark">
                <span class="${p}-rich-percentile-number"></div>
            </div>

            <div class="${p}-rich-percentile-wealth">
                <span class="${p}-rich-percentile-wealth-number"></div>
            </div>

            <div class="${p}-half-percentile-mark">
                <span class="${p}-half-percentile-number"></div>
            </div>

            <div class="${p}-half-percentile-wealth">
                <span class="${p}-half-percentile-wealth-number"></div>
            </div>

            <div class="${p}-intro-text">
                <div class="${p}-intro-title">
                    <div class="${p}-intro-main-bg"></div>
                    <div class="${p}-title-text">Land der <br>Ungleichheit</div>
                </div>

                <div class="${p}-intro-subtitle">
                <div class="${p}-intro-sub-bg"></div>
                    So ungleich ist Vermögen in Österreich verteilt
                </div>
            </div>

            <div class="${p}-beat-text""></div>

            <div class="${p}-scene">
                <div class="${p}-mountains" style="background-image: url(${a}/img/mountains.png)"></div>

                <div class="${p}-cityscape">
                    <div class="${p}-dc-tower">
                        <img class="${p}-dc-tower-top" src="${a}/img/dc-tower-top.png" />
                        <div class="${p}-dc-tower-repeat">
                            <div class="${p}-estimated-wealth-holder">
                                <div class="${p}-estimated-wealth-line"></div>
                                <div class="${p}-estimated-wealth-text"></div>
                            </div>
                        </div>
                    </div>

                    <div class="${p}-buildings-left">
                        <img class="${p}-buildings-img" src="${a}/img/buildings-left.png" />
                        <img class="${p}-buildings-img ${p}-buildings-img-left-2" src="${a}/img/buildings-left-2.png" />
                    </div>

                    <div class="${p}-fence" style="background-image: url(${a}/img/fence.png)"></div>


                    <img class="${p}-bus-stop" src="${a}/img/bus-stop.png" />

                    <div class="${p}-buildings-right">
                        <img class="${p}-buildings-img" src="${a}/img/buildings-right.png" />
                        <img class="${p}-buildings-img ${p}-buildings-img-right-2" src="${a}/img/buildings-right-2.png" />
                    </div>
                </div>
            </div>

            <div class="${p}-maria-thomas-holder ${p}-comic-frame">
                <img class="${p}-comic-img ${p}-maria-thomas" src="${a}/img/maria-thomas.jpg" />
                <img class="${p}-comic-arrow ${p}-comic-arrow-maria-thomas" src="${comicArrow}" />
            </div>

            <div class="${p}-angelika-holder ${p}-comic-frame">
                <img class="${p}-comic-img ${p}-angelika" src="${a}/img/angelika.jpg" />
                <img class="${p}-comic-arrow ${p}-comic-arrow-angelika" src="${comicArrow}" />
            </div>
        `;
    }

    /** @override */
    reset() {
    }

    /** @override */
    resize() {
        // Don't show the loader on the last step becase on mobile the focus triggers a resize and it is very
        // strange having a loader popup.
        if (this.currentStoryBeatId !== BEATS.CALCULATOR) {
            // bug in framework so I have to do it manually.
            this.holder.find('.add-ds-loader-holder').show();

            // Reset camera so I can get the normal BBoxes.
            // Must happen before I refresh the bbox cache.
            this.resetCamera();

            // Refresh the bbox caches.
            // !!! Important, this must happen before the camera is updated since it depends on the cache.
            this.refreshMarkerBboxCache();

            // Put camera back.
            this.setCameraForBeat(this.currentStoryBeatId, 0);
        }

        switch(this.currentStoryBeatId) {
            case BEATS.BEAT_2:
                this.respositionMariaThomas();
                break;

            case BEATS.BEAT_5:
                this.respositionComicFrame('angelika-holder', 'angelika');
                break;
        }

        setTimeout(this.hideLoader.bind(this), 1250);

        super.resize();
    }

    simpleCopyObject(obj) {
        return JSON.parse(JSON.stringify(obj));
    }

    resetCamera() {
        this.setCamera({
            y: 100,
            duration: 0,
            zoom: 1
        });
    }

    /** @override */
    setState(state, beatId, beatIndex) {
        let cameraDuration = state.cameraDuration;
        let beatTextDelay = state.beatTextDelay;
        let barsDelay = state.barsDelay;

        // Going backwards we want to use the same timing as we went forward.
        if (beatIndex < this.currentStoryBeatIndex) { // This is bugged, need to check.
            cameraDuration = this.storyBeats.get(this.currentStoryBeatId)?.cameraDuration;
            beatTextDelay = this.storyBeats.get(this.currentStoryBeatId)?.beatTextDelay;
            barsDelay = this.storyBeats.get(this.currentStoryBeatId)?.barsDelay;
        }

        super.setState(state, beatId, beatIndex);

        // We have a custom animation running on the intro text during the initial load of the story so we need to ignore
        // the set state of the intro text here so it does not override the animations.
        if (this.storyStarted === true) {
            this.setCameraForBeat(beatId, cameraDuration);

            if (beatId === BEATS.INTRO) {
                this.showIntroText();
            } else {
                this.hideIntroText();
            }
        }

        if (state.text) {
            this.setBeatText(state.text, beatTextDelay, state.textShake);
        } else {
            this.hideBeatText();
        }


        (state.showMariaThomas === true) ? this.showMariaThomas(cameraDuration) : this.hideMariaThomas();
        (state.showAngelika === true) ? this.showAngelika(cameraDuration) : this.hideAngelika();

        (state.showIncomeBubbles) ? this.showIncomeBubbles(beatId) : this.hideAllIncomeBubbles();

        (state.showInput === true) ? this.showInput(beatTextDelay) : this.hideInput();

        if (state.showGhostbuildings === true) {
            this.showGhostbuildings(cameraDuration);
        } else {
            this.hideGhostBuildings();
        }

        if (state.showRichPercentile) {
            this.showRichPercentile(
                state.showRichPercentile,
                state.showRichPercentileLabel,
                state.showRichPercentileLabelLeftPos,
                barsDelay
            );
        } else {
            this.hideRichPercentile();
        }

        if (state.showRichPercentileWealth)  {
            this.showRichPercentileWealth(
                state.showRichPercentileWealth,
                state.animateRichPercentileWealth,
                barsDelay
            );
        } else {
            this.hideRichPercentileWealth();
        }

        if (state.showHalfPercentile) {
            this.showHalfPercentile(state.showHalfPercentile, barsDelay);
        } else {
            this.hideHalfPercentile();
        }

        if (state.showHalfPercentileWealth) {
            this.showHalfPercentileWealth(state.showHalfPercentileWealth, barsDelay);
        } else {
            this.hideHalfPercentileWealth();
        }

        (state.taxationPercentile) ? this.showTaxationPercentile(state.taxationPercentile, state.taxationLabel, cameraDuration) : this.hideTaxationPercentile();

        // Shoulf refactor this to another prop
        (state.showRichPercentile) ? this.fadeOutBgElements() : this.resetOpacityBgElements();
    }

    showGhostbuildings(delay = 1000): void {
        let extraDelay = 250;
        this.find('buildings-img-right-2').css('transition-delay', `${delay + extraDelay}ms`).addClass('show');

        let extraDelay = 250;
        this.find('buildings-img-left-2').css('transition-delay', `${delay + extraDelay}ms`).addClass('show');

        extraDelay += 250;
        this.find('bus-stop').css('transition-delay', `${delay + extraDelay}ms`).addClass('show');
    }

    hideGhostBuildings(): void {
        this.find('buildings-ghosts').css('transition-delay', '0ms').removeClass('show');
        this.find('bus-stop').css('transition-delay', '0ms').removeClass('show');
    }

    showTaxationPercentile(percentile, label, delay) {
        this.taxationBarTimeoutId =  setTimeout(() => {
            const bbox = this.find('dc-tower-repeat')[0].getBoundingClientRect();
            const scale = bbox.bottom - bbox.top;
            const height = scale / 100 * percentile;
            const barWidth = 30;
            const xOffset = (bbox.width / 2) + barWidth + 10;

            this.find('taxation-bar').css({
                height: `${height}px`,
                width: `${barWidth}px`,
                left: '50%',
                top: `${bbox.top}px`,
                transform: `translate(${xOffset}px, 0)`,
                opacity: 1
            });

            this.find('taxation-label').html(`${label}`);
        }, delay);
    }

    hideTaxationPercentile() {
        clearTimeout(this.taxationBarTimeoutId);
        this.find('taxation-bar').css({
            height: 0,
            opacity: 0
        });
    }

    fadeOutBgElements(): void {
        const o = 0.3;
        this.find('buildings-left').css('opacity', o);
        this.find('buildings-right').css('opacity', o);
        this.find('fence').css('opacity', o);
        this.find('mountains').css('opacity', o);
    }

    resetOpacityBgElements() {
        this.find('buildings-left').css('opacity', 1);
        this.find('buildings-right').css('opacity', 1);
        this.find('fence').css('opacity', 1);
        this.find('mountains').css('opacity', 1);
    }

    showHalfPercentile(percentile, delay = 0): void {
        clearTimeout(this.showHalfPercentileTimeoutId);

        this.showHalfPercentileTimeoutId = setTimeout(() => {
            const bbox = this.find('dc-tower-repeat')[0].getBoundingClientRect();
            const scale = bbox.bottom - bbox.top;
            const height = scale / 100 * percentile;
            const barWidth = 30;
            const xOffset = (bbox.width / 2) + barWidth + 5;

            this.find('half-percentile-mark').css({
                height: `${height}px`,
                width: `${barWidth}px`,
                left: '50%',
                transform: `translate(${-xOffset}px, 0)`,
                opacity: 1
            });

            this.find('half-percentile-number').html(`${percentile}%`);
        }, delay + 50);
    }

    hideHalfPercentile() {
        clearTimeout(this.showHalfPercentileTimeoutId);
        this.find('half-percentile-mark').css({
            height: 0,
            opacity: 0
        });
    }

    showHalfPercentileWealth(percentile, delay = 0) {
        clearTimeout(this.showHalfPercentileWealthTimeoutId);

        this.showHalfPercentileWealthTimeoutId =  setTimeout(() => {
            const bbox = this.find('dc-tower-repeat')[0].getBoundingClientRect();
            const scale = bbox.bottom - bbox.top;
            const height = scale / 100 * percentile;
            const barWidth = 30;
            const xOffset = (bbox.width / 2) + 5;

            this.find('half-percentile-wealth').css({
                height: `${height}px`,
                width: `${barWidth}px`,
                left: '50%',
                transform: `translate(${xOffset}px, 0)`,
                opacity: 1
            });

            this.find('half-percentile-wealth-number').html(`${this.numberFormatter.default(percentile)}%`);
        }, delay + 50);
    }

    hideHalfPercentileWealth() {
        clearTimeout(this.showHalfPercentileWealthTimeoutId);
        this.find('half-percentile-wealth').css({
            height: 0,
            opacity: 0
        });
    }

    showRichPercentileWealth(percentile, animateRichPercentileWealth = false, delay = 0): void {
        clearTimeout(this.showRichPercentileWealthTimeoutId);

        this.showRichPercentileWealthTimeoutId =  setTimeout(() => {
            const $number = this.find('rich-percentile-wealth-number');
            const $bar = this.find('rich-percentile-wealth');

            const bbox = this.find('dc-tower-repeat')[0].getBoundingClientRect();
            const scale = bbox.bottom - bbox.top;
            const height = scale / 100 * percentile;
            const barWidth = 30;

            const xOffset = (bbox.width / 2) + 5;

            $bar.css({
                height: `${height}px`,
                width: `${barWidth}px`,
                top: `${bbox.top}px`,
                left: '50%',
                transform: `translate(${xOffset}px, 0)`,
                opacity: 1
            });

            $number.html(`${percentile}%`);

            if (animateRichPercentileWealth === true) {
                $bar.addClass('animate');
            } else {
                $bar.removeClass('animate');
            }
        }, delay + 50);
    }

    hideRichPercentileWealth(): void {
        clearTimeout(this.showRichPercentileWealthTimeoutId);

        this.find('rich-percentile-wealth').css({
            height: 0,
            opacity: 0
        });
    }

    showRichPercentile(percentile, label, labelLeftPos, delay = 0) {
        clearTimeout(this.showRichPercentileTimeoutId);
        label = (!label) ? `${percentile}%` : label;
        labelLeftPos = (!labelLeftPos) ? 0 : labelLeftPos;

        this.showRichPercentileTimeoutId = setTimeout(() => {
            const bbox = this.find('dc-tower-repeat')[0].getBoundingClientRect();
            const scale = bbox.bottom - bbox.top;
            const barWidth = 30;

            const height = scale / 100 * percentile;
            const xOffset = (bbox.width / 2) + barWidth + 5;

            this.find('rich-percentile-mark').css({
                height: `${height}px`,
                width: `${barWidth}px`,
                top: `${bbox.top}px`,
                left: '50%',
                transform: `translate(${-xOffset}px, 0)`,
                opacity: 1
            });

            this.find('rich-percentile-number').html(`${label}`);
        }, delay + 50);
    }

    hideRichPercentile() {
        clearTimeout(this.showRichPercentileTimeoutId);
        this.find('rich-percentile-mark').css({
            height: 0,
            opacity: 0
        });
    }

    showIncomeBubbles(beatId) {
        this.hideAllIncomeBubbles();
        this.find(`income-bubble-${beatId}`).css('opacity', 1);
    }

    hideAllIncomeBubbles() {
        this.find('income-bubble').css('opacity', 0);
    }


    showInput(delay: number): void {
        setTimeout(() => {
            this.find('input-holder').fadeIn();
        }, delay);
    }

    hideInput(): void {
        this.find('input-holder').hide();
    }

    showMariaThomas(delay = 1000) {
        // We need a timeout to wait for the zooming to end.
        this.mariaThomasTimeoutId = setTimeout(() => {
            const $mt = this.find('maria-thomas-holder');
            $mt.css({'display': 'block'});

            this.respositionMariaThomas();

            setTimeout(() => {
                $mt.css({
                    'transition-duration': '500ms',
                    opacity: 1
                });
            }, 50);

        }, delay);
    }

    respositionMariaThomas() {
        const $mt = this.find('maria-thomas-holder');

        // Get the zoomed in bounding rect.
        // not this should happen after the zooming is finished.
        const offsetMarker = this.markers['mariathomas'].$el[0].getBoundingClientRect();

        // Position the frame right above the marker.
        $mt.css({
            left: offsetMarker.left,
            top: offsetMarker.top
        });
    }

    hideMariaThomas() {
        clearTimeout(this.mariaThomasTimeoutId);

        this.find('maria-thomas-holder').css({
            'display': 'none',
            'opacity': 0
        });
    }

    showAngelika(delay = 1000) {
        this.showAngelikaTimeoutId = setTimeout(() => {
            const $mt = this.find('angelika-holder');
            $mt.css({'display': 'block'});

            this.respositionComicFrame('angelika-holder', 'angelika2');

            setTimeout(() => {
                $mt.css({
                    'transition-duration': '500ms',
                    opacity: 1
                });
            }, 50);
        }, delay);
    }

    hideAngelika() {
        clearTimeout(this.showAngelikaTimeoutId);

        this.find('angelika-holder').css({
            display: 'none',
            opacity: 0
        });
    }

    respositionComicFrame(sel, markerId) {
        const $mt = this.find(sel);

        // Get the zoomed in bounding rect.
        // not this should happen after the zooming is finished.
        const offsetMarker = this.markers[markerId].$el[0].getBoundingClientRect();

        // Position the frame right above the marker.
        $mt.css({
            left: offsetMarker.left,
            top: offsetMarker.top
        });
    }


    setCameraForBeat(beatId: string, duration = 1000): void {
        const holderWidth = <number>this.holder.width();
        const halfHolderWidth = holderWidth / 2;
        let offsetX = 0;
        const angelikaMarker2 = this.markers['angelika2'];
        const $scene = this.find('scene');
        const sceneHeight = <number>$scene.height();

        let zoom = 1;

        let yOffset = 0;

        switch(beatId) {
            case BEATS.INTRO:
                this.setCamera({
                    y: 100,
                    zoom: 1,
                    duration: duration
                });
                break;

            case BEATS.BEAT_2:
                offsetX = (holderWidth * this.markers['mariathomas'].xCenter / 100) - halfHolderWidth;
                zoom = 1.4;

                this.setCamera({
                    x: this.markers['mariathomas'].xCenter,
                    y: 100,
                    zoom: zoom,
                    duration: duration
                });
                break;

            case BEATS.BEAT_3:
                offsetX = (holderWidth * this.markers['beat3'].xCenter / 100) - halfHolderWidth;

                if (holderWidth > 2000) {
                    zoom = 1.8;
                } else {
                    zoom = 1.2;
                }

                this.setCamera({
                    x: this.markers['beat3'].xCenter,
                    y: 100,
                    zoom: zoom,
                    duration: duration
                });
                break;

            case BEATS.BEAT_4:
                if (holderWidth > 2000) {
                    zoom = 2;
                } else {
                    zoom = 1.4;
                }
                offsetX = (holderWidth * this.markers['beat4'].xCenter / 100) - halfHolderWidth;

                this.setCamera({
                    x: this.markers['beat4'].xCenter,
                    y: this.markers['beat4'].yCenter,
                    zoom: zoom,
                    duration: duration
                });
                break;

            case BEATS.BEAT_5:
            case BEATS.BEAT_6:
            case BEATS.BEAT_13:
            case BEATS.BEAT_14:
                this.setCamera({
                    xOffset: offsetX,
                    y: angelikaMarker2.yCenter,
                    zoom: 0.8,
                    duration: duration
                });
                break;

            case BEATS.BEAT_7:
            case BEATS.BEAT_8:
            case BEATS.BEAT_9:
            case BEATS.BEAT_10:
            case BEATS.BEAT_11:
            case BEATS.BEAT_12:
                if (window.innerWidth < 500) {
                    zoom = (window.innerHeight - (window.innerHeight * 0.35)) / sceneHeight;
                } else {
                    zoom = (window.innerHeight - (window.innerHeight * 0.2)) / sceneHeight;
                }

                this.setCamera({
                    xOffset: offsetX,
                    y: 100,
                    zoom: zoom,
                    duration: duration
                });
                break;

            case BEATS.BEAT_15:
                this.setCamera({
                    y: 100,
                    zoom: 0.7,
                    duration: duration
                });
                break;

            case BEATS.CALCULATOR:
                this.setCamera({
                    y: 100,
                    zoom: 0.6,
                    duration: duration
                });
                break;
        }
    }

    defineBeats() {
        const formattedAverageIncome = this.numberFormatter.default(this.averageIncome);


        this.addBeat(BEATS.INTRO, {
        });

        this.addBeat(BEATS.BEAT_2, {
            cameraDuration: 1500,
            beatTextDelay: 1500,
            showMariaThomas: true,
            textCoords:{
                left: 5,
                top: 5
            },
            text: 'Das sind Maria und Thomas. Sie haben gemeinsam 12.000 Euro gespart. Das war schwierig: Immerhin müssen sie mit je 1.800 Euro Nettoeinkommen auch Miete, Lebensmittel und so weiter bezahlen.'
        });

        this.addBeat(BEATS.BEAT_3, {
            showIncomeBubbles: true,
            cameraDuration: 1000,
            beatTextDelay: 1000,
            textCoords:{
                left: 5,
                top: 5
            },
            text: `Im österreichweiten Vergleich ist ihr Vermögen trotzdem unterdurchschnittlich klein: Das mittlere Vermögen ist hierzulande mit ${formattedAverageIncome} Euro fast siebenmal so hoch.`
        });

        this.addBeat(BEATS.BEAT_4, {
            showIncomeBubbles: true,
            cameraDuration: 1000,
            beatTextDelay: 1000,
            textCoords:{
                left: 5,
                top: 5
            },
            text: 'Mit einer halben Million Euro zählt man zu den reichsten zehn Prozent. Diese Haushalte besitzen meist ein abbezahltes Eigenheim sowie Geldanlagen.'
        });

        this.addBeat(BEATS.BEAT_5, {
            cameraDuration: 3000,
            beatTextDelay: 3000,
            showAngelika: true,
            textCoords:{
                left: 5,
                top: 5
            },
            text: 'Häuser, Aktien, Unternehmen: In diesen Sphären bewegen sich Superreiche wie Angelika und Albert. Ab 2,2 Millionen Euro zählt man zum reichsten Prozent.'
        });

        this.addBeat(BEATS.BEAT_6, {
            cameraDuration: 1000,
            beatTextDelay: 0,
            showAngelika: true,
            textCoords:{
                left: 5,
                top: 5
            },
            text: 'Diese Daten stammen aus einer Erhebung der Oesterreichischen Nationalbank. Die erfassten Werte repräsentieren rund vier Millionen Haushalte in Österreich.'
        });

        this.addBeat(BEATS.BEAT_7, {
            showRichPercentile: 1,
            showRichPercentileWealth: 23,
            cameraDuration: 2000,
            beatTextDelay: 2000,
            barsDelay: 2050,
            textCoords:{
                left: 10,
                top: 5
            },
            text: 'Die Angaben des reichsten Prozents zeigen, dass sie rund 23 Prozent des gesamten Vermögens (985 Milliarden Euro) besitzen.'
        });

        this.addBeat(BEATS.BEAT_8, {
            showRichPercentile: 1,
            showRichPercentileWealth: 23,
            cameraDuration: 1000,
            beatTextDelay: 0,
            barsDelay: 0,
            textCoords:{
                left: 10,
                top: 5
            },
            text: 'Allerdings gibt es einen Haken: Superreiche Haushalte sind für die Umfrage der Nationalbank kaum zu erreichen. Entweder sind sie in der Stichprobe nicht enthalten oder verweigern die Teilnahme.'
        });

        this.addBeat(BEATS.BEAT_9, {
            showRichPercentile: 1,
            showRichPercentileWealth: 39,
            animateRichPercentileWealth: true,
            cameraDuration: 1000,
            beatTextDelay: 0,
            barsDelay: 0,
            textCoords:{
                left: 10,
                top: 5
            },
            text: 'Vermögen ist also in Wahrheit noch viel ungleicher verteilt. Das reichste Prozent besitzt sogar 39 Prozent des Vermögens. Das zeigt eine Studie der Arbeiterkammer.'
        });

        this.addBeat(BEATS.BEAT_10, {
            showRichPercentile: 10,
            showRichPercentileWealth: 66,
            animateRichPercentileWealth: true,
            cameraDuration: 1000,
            beatTextDelay: 0,
            barsDelay: 0,
            textCoords:{
                left: 10,
                top: 5
            },
            text: 'Wird das Vermögen der fehlenden Superreichen hinzu geschätzt, ergibt sich: Die reichsten zehn Prozent verfügen über zwei Drittel des Gesamtvermögens.'
        });

        this.addBeat(BEATS.BEAT_11, {
            showRichPercentile: 10,
            showRichPercentileWealth: 66,
            showHalfPercentile: 50,
            showHalfPercentileWealth: 2.8,
            animateRichPercentileWealth: true,
            cameraDuration: 1000,
            beatTextDelay: 0,
            barsDelay: 0,
            textCoords:{
                left: 10,
                top: 5
            },
            text: 'Die Hälfte der Haushalte verfügt gemeinsam dagegen nur über 2,8 Prozent des ganzen Vermögens.'
        });

        this.addBeat(BEATS.BEAT_12, {
            showRichPercentile: 10,
            showRichPercentileWealth: 66,
            showHalfPercentile: 50,
            showHalfPercentileWealth: 2.8,
            animateRichPercentileWealth: true,
            cameraDuration: 1500,
            beatTextDelay: 0,
            barsDelay: 0,
            textShake: true,
            textCoords:{
                left: 10,
                top: 5
            },
            text: 'Das ist nicht gerecht! Wie kann diese Schieflage verbessert werden? Vermögende wie Angelika und Albert müssen endlich einen fairen Beitrag leisten. Wie das geht?'
        });

        this.addBeat(BEATS.BEAT_13, {
            showAngelika: true,
            cameraDuration: 3000,
            beatTextDelay: 3000,
            barsDelay: 3000,
            textCoords:{
                left: 10,
                top: 5
            },
            text: 'Reiche Menschen sollen Vermögenssteuer zahlen. Ein Tarif von einem Prozent ab einer Million Euro Vermögen würde beispielsweise fünf Milliarden Euro bringen.'
        });

        this.addBeat(BEATS.BEAT_14, {
            showAngelika: true,
            cameraDuration: 1000,
            beatTextDelay: 0,
            textCoords:{
                left: 10,
                top: 5
            },
            text: 'Ein vierstufiger Tarif – von einem Prozent auf Vermögen ab einer Million Euro bis vier Prozent ab einer Milliarde Euro – könnte jährlich bis zu elf Milliarden Euro bringen.'
        });

        this.addBeat(BEATS.BEAT_15, {
            cameraDuration: 3000,
            beatTextDelay: 3000,
            showGhostbuildings: true,
            textCoords:{
                left: 10,
                top: 5
            },
            text: 'Damit könnten wichtige Investitionen getätigt und der Sozialstaat ausgebaut werden. Von Schulen, Spitälern, Ausbau der Pflege, etc. würden alle Menschen profitieren.'
        });

        this.addBeat(BEATS.CALCULATOR, {
            disableControls: true,
            cameraDuration: 1500,
            beatTextDelay: 1500,
            showGhostbuildings: true,
            textCoords:{
                left: 10,
                top: 5
            },
            text: 'Nun sind Sie am Zug: Wie hoch schätzen Sie Ihr Vermögen im Haushalt? Denken Sie auch an Autos, Immobilien, Grundstücke, Erspartes, etc. und ziehen Sie Schulden ab. Ihre Eingaben werden nicht gespeichert.',
            showInput: true
        });
    }

    /**
     * Story specific API.
     */
    showIntroText(): void {
        this.find('intro-text').fadeIn();
    }

    hideIntroText(): void {
        this.find('intro-text').hide();
    }

    setBeatText(text: string, delay = 1000, textShake = false): void {
        clearTimeout(this.beatTextTimeoutId);

        const duration = 350;

        const $beatText = this.find('beat-text');
        $beatText.removeClass('shake');
        $beatText.stop(true, true).fadeTo(duration, 0);

        const toggleBeatText = () => {
                this.beatTextTimeoutId = setTimeout(() => {
                    $beatText.html(text).stop(true, true).fadeTo(duration, 1);

                    $beatText.css({
                        'transition-property': 'none',
                        left: '0%'
                    });

                    setTimeout(() => {
                        $beatText.css({
                            'transition-property': 'left',
                            left: `5%`,
                        });

                        if (textShake === true) {
                            $beatText.addClass('shake');
                        }
                    }, 50)

                }, duration + 50);
        }

        if (delay > 0) {
            this.beatTextTimeoutId = setTimeout(toggleBeatText.bind(this), delay - duration);
        } else {
            toggleBeatText();
        }
    }

    hideBeatText(): void {
        this.find('beat-text').stop(true, true).fadeTo(500, 0);
        clearTimeout(<nunber>this.beatTextTimeoutId);
    }

    setTitle(title: string): void {
        this.find('title-text').html(title);
    }

    hideTitle(duration = 1000) {
        const $title = this.find('title');

        if (duration > 0) {
            $title.fadeOut(duration);
        } else {
            $title.hide();
        }
    }

    generateBgClouds(): void {
        // Remove all clouds.
        this.find('bg-cloud').remove();

        const amountOfClouds = Math.ceil(<number>this.holder.width() / 200) * 4;

        // Place some clouds in the first screen.
        for (let i = 0; i < amountOfClouds; i++) {
            this.generateCloud(10, 90);
        }
    }

    generateCloud(min: number, max: number): void {
        const clouds = [cloud1PNG, cloud2PNG];

        const cloudId = this.getRandomNumber(0, 1);
        const posY = this.getRandomNumber(min, max);
        const posX = this.getRandomNumber(0, 100);
        const width = this.getRandomNumber(30, 70);
        const html = `<img class="${this.projectPrefix}-bg-cloud" src="${clouds[cloudId]}" style="top: ${posY}%; left: ${posX}%; width: ${width}px" />`;

        this.find('scene').append(html);
    }

    layoutCityStructure() {
        let html = this.layoutDcTower();

        this.find('dc-tower-repeat').append(html);

        // After the buildings are appended I can generate the clouds separating the 1%.
        this.generateBigClouds();

        // Add income buildings to buildings for beat 3.
        this.addIncomeBubbles();

        // this.generatePercentileLines();
    }

    layoutDcTower(): string {
        const p = this.projectPrefix;
        const dcTowerWidthRelative = 33.33; // Width in percentage.
        const dcTowerMaxWidth = 300; // Pixels.
        const holderWidth = <number>this.holder.width();

        // Calculate dcTower width from the relative and immediately choose the smallest value compared to the max.
        let dcTowerWidth = Math.min(holderWidth / 100 * dcTowerWidthRelative, dcTowerMaxWidth);


        // Use 4 screen heights as the tower height.
        let dcTowerMaxHeight = <number>this.holder.height() * 4;

        dcTowerMaxHeight = Math.min(dcTowerMaxHeight, 6000);

        if (this.holder.width() > 1000 && dcTowerMaxHeight < 6000) {
            dcTowerMaxHeight = 5000;
        } else if (this.holder.width() < 460) {
            dcTowerMaxHeight = <number>this.holder.height() * 3;
        }

        const ratio = 0.80625; // ratio width to hegiht of dc tower elements.

        const dcRepeatPartsHeight = dcTowerWidth * ratio;

        // TOP element is not symmetrical to the other 2 parts, this will be a problem.
        const repeat = Math.floor(dcTowerMaxHeight / 2 / dcRepeatPartsHeight) - 1;

        let html = '';

        for (let i = 0; i < repeat; i++) {
            html += `
                <img src="${this.assetLocation}img/dc-tower-r1.png" />
                <img src="${this.assetLocation}img/dc-tower-r2.png" />
            `;

            if (i === 0) {
                html += `<div class="${this.projectPrefix}-1-percent-marker"></div>`
            }
        }

        return html;
    }

    generateBigClouds(): void {
        const topY = 100 / this.viewportMultiply;
        let html = '';
        const cls = `${this.projectPrefix}-big-cloud`;

        let width = this.getRandomNumber(550, 650);
        html += `<img class="${cls}" src="${cloud1SVG}" style="top: 0px; transform: translate(${-50}%, ${-42}%); width: ${width}px" />`;

        width = this.getRandomNumber(550, 650);
        html += `<img class="${cls}" src="${cloud1SVG}" style="top: 0px; transform: translate(${-83}%, ${-22}%); width: ${width}px" />`;

        width = this.getRandomNumber(550, 650);
        html += `<img class="${cls}" src="${cloud1SVG}" style="top: 0px; transform: translate(${0}%, ${-10}%); width: ${width}px" />`;

        width = this.getRandomNumber(550, 650);
        html += `<img class="${cls}" src="${cloud1SVG}" style="top: 0px; transform: translate(${25}%, ${-41}%); width: ${width}px" />`;

        width = this.getRandomNumber(550, 650);
        html += `<img class="${cls}" src="${cloud1SVG}" style="top: 0px; transform: translate(${-130}%, ${-27}%); width: ${width}px" />`;

        width = this.getRandomNumber(550, 650);
        html += `<img class="${cls}" src="${cloud1SVG}" style="top: 0px; transform: translate(${-80}%, ${-5}%); width: ${width}px" />`;

        this.find('1-percent-marker').append(html);
    }

    generatePercentileLines() {
        const p = this.projectPrefix;
        let html = '';

        for (let i = 1; i <= 100; i++) {
            html += `<div class="${p}-percentile-line ${p}-percentile-line-${i}" style="top: ${i}%"></div>`;
        }

        this.find('dc-tower-repeat').append(html);
    }

    setCamera({x = 50, y = 0, xOffset = 0, yOffset = 0, zoom = 1, duration = 1000} = {}) {
        this.zoom = zoom;

        const $scene = this.find('scene');
        const sceneHeight = <number>$scene.height();

        const holderHeight = <number>this.holder.height();
        const holderCenterX = <number>this.holder.width() / 2;
        const holderCenterY = holderHeight / 2;

        // let maxYOffset = <number>this.find('scene').outerHeight() - <number>this.holder.outerHeight();

        const scaledSceneWidth = <number>$scene.width() * this.zoom;
        const scaledSceneHeight = <number>$scene.height() * this.zoom;

        const scaledSceneCenterX = x / 100 * scaledSceneWidth;
        const scaledSceneCenterY = y / 100 * scaledSceneHeight;

        let tx = holderCenterX - scaledSceneCenterX;


        let ty = holderCenterY - scaledSceneCenterY;

        if (scaledSceneHeight + ty < holderHeight) {
            ty += (holderHeight - (scaledSceneHeight + ty));
        }

        this.find('scene').css({
            'transition-duration': `${duration}ms`,
            transform: `translate3d(${tx}px, ${ty}px, 0) scale(${zoom})`
        });
    }

    getRandomNumber(min, max): number {
        return Math.round(Math.random() * (max - min) + min);
    }

    extendJqueryEasings () {
        var pow = Math.pow,
        sqrt = Math.sqrt,
        sin = Math.sin,
        cos = Math.cos,
        PI = Math.PI,
        c1 = 1.70158,
        c2 = c1 * 1.525,
        c3 = c1 + 1,
        c4 = ( 2 * PI ) / 3,
        c5 = ( 2 * PI ) / 4.5;

        // x is the fraction of animation progress, in the range 0..1
        function bounceOut(x) {
            var n1 = 7.5625,
                d1 = 2.75;
            if ( x < 1/d1 ) {
                return n1*x*x;
            } else if ( x < 2/d1 ) {
                return n1*(x-=(1.5/d1))*x + 0.75;
            } else if ( x < 2.5/d1 ) {
                return n1*(x-=(2.25/d1))*x + 0.9375;
            } else {
                return n1*(x-=(2.625/d1))*x + 0.984375;
            }
        }

        this.$.extend(this.$.easing, {
            // Don't use this. Breaks jQuery and figuring out the issue is not worth it since I will not use these effects.
            // def: 'easeOutQuad',
            // swing: function (x) {
            // 	return this.easing[this.easing.def](x);
            // },
            easeInQuad: function (x) {
                return x * x;
            },
            easeOutQuad: function (x) {
                return 1 - ( 1 - x ) * ( 1 - x );
            },
            easeInOutQuad: function (x) {
                return x < 0.5 ?
                    2 * x * x :
                    1 - pow( -2 * x + 2, 2 ) / 2;
            },
            easeInCubic: function (x) {
                return x * x * x;
            },
            easeOutCubic: function (x) {
                return 1 - pow( 1 - x, 3 );
            },
            easeInOutCubic: function (x) {
                return x < 0.5 ?
                    4 * x * x * x :
                    1 - pow( -2 * x + 2, 3 ) / 2;
            },
            easeInQuart: function (x) {
                return x * x * x * x;
            },
            easeOutQuart: function (x) {
                return 1 - pow( 1 - x, 4 );
            },
            easeInOutQuart: function (x) {
                return x < 0.5 ?
                    8 * x * x * x * x :
                    1 - pow( -2 * x + 2, 4 ) / 2;
            },
            easeInQuint: function (x) {
                return x * x * x * x * x;
            },
            easeOutQuint: function (x) {
                return 1 - pow( 1 - x, 5 );
            },
            easeInOutQuint: function (x) {
                return x < 0.5 ?
                    16 * x * x * x * x * x :
                    1 - pow( -2 * x + 2, 5 ) / 2;
            },
            easeInSine: function (x) {
                return 1 - cos( x * PI/2 );
            },
            easeOutSine: function (x) {
                return sin( x * PI/2 );
            },
            easeInOutSine: function (x) {
                return -( cos( PI * x ) - 1 ) / 2;
            },
            easeInExpo: function (x) {
                return x === 0 ? 0 : pow( 2, 10 * x - 10 );
            },
            easeOutExpo: function (x) {
                return x === 1 ? 1 : 1 - pow( 2, -10 * x );
            },
            easeInOutExpo: function (x) {
                return x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ?
                    pow( 2, 20 * x - 10 ) / 2 :
                    ( 2 - pow( 2, -20 * x + 10 ) ) / 2;
            },
            easeInCirc: function (x) {
                return 1 - sqrt( 1 - pow( x, 2 ) );
            },
            easeOutCirc: function (x) {
                return sqrt( 1 - pow( x - 1, 2 ) );
            },
            easeInOutCirc: function (x) {
                return x < 0.5 ?
                    ( 1 - sqrt( 1 - pow( 2 * x, 2 ) ) ) / 2 :
                    ( sqrt( 1 - pow( -2 * x + 2, 2 ) ) + 1 ) / 2;
            },
            easeInElastic: function (x) {
                return x === 0 ? 0 : x === 1 ? 1 :
                    -pow( 2, 10 * x - 10 ) * sin( ( x * 10 - 10.75 ) * c4 );
            },
            easeOutElastic: function (x) {
                return x === 0 ? 0 : x === 1 ? 1 :
                    pow( 2, -10 * x ) * sin( ( x * 10 - 0.75 ) * c4 ) + 1;
            },
            easeInOutElastic: function (x) {
                return x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ?
                    -( pow( 2, 20 * x - 10 ) * sin( ( 20 * x - 11.125 ) * c5 )) / 2 :
                    pow( 2, -20 * x + 10 ) * sin( ( 20 * x - 11.125 ) * c5 ) / 2 + 1;
            },
            easeInBack: function (x) {
                return c3 * x * x * x - c1 * x * x;
            },
            easeOutBack: function (x) {
                return 1 + c3 * pow( x - 1, 3 ) + c1 * pow( x - 1, 2 );
            },
            easeInOutBack: function (x) {
                return x < 0.5 ?
                    ( pow( 2 * x, 2 ) * ( ( c2 + 1 ) * 2 * x - c2 ) ) / 2 :
                    ( pow( 2 * x - 2, 2 ) *( ( c2 + 1 ) * ( x * 2 - 2 ) + c2 ) + 2 ) / 2;
            },
            easeInBounce: function (x) {
                return 1 - bounceOut( 1 - x );
            },
            easeOutBounce: bounceOut,
            easeInOutBounce: function (x) {
                return x < 0.5 ?
                    ( 1 - bounceOut( 1 - 2 * x ) ) / 2 :
                    ( 1 + bounceOut( 2 * x - 1 ) ) / 2;
            }
        });
    }



    addMarkers(): void {
        // Markers for the buildings on the right.
        this.addMarker('mariathomas', 'buildings-right', 6.05, 75);

        this.addMarker('beat3', 'buildings-right', 25, 75);

        this.addMarker('beat4', 'buildings-right', 7, -5);

        // this.addMarker('angelika', 'dc-tower-repeat', 100, 10);

        this.addMarker('angelika', 'dc-tower', 50, 12.5);

        this.addMarker('angelika2', '1-percent-marker', 50, 0);
    }

    addMarker(id: string, sel: string, left: number, top: number): void {
        if (this.markers[id]) console.debug(`A marker for ${id} already exists. Please check.`);

        // In debug mode we show them, otherwise they are hidden.
        const opacity = (this.debug === true) ? 1 : 0;
        const finalId = `${this.projectPrefix}-marker-${id}`;

        const markersHtml = `
            <div id="${finalId}" class="marker" style="left: ${left}%; top: ${top}%; opacity: ${opacity};"></div>
        `;

        this.find(sel).append(markersHtml);

        this.markers[id] = {
            $el: this.$(`#${finalId}`),
        }

        this.calculateMarkerCoordData(this.markers[id]);
    }

    calculateMarkerCoordData(obj) {
        const $el = obj.$el;
        const bbox = this.simpleCopyObject($el[0].getBoundingClientRect());
        const x = bbox.left; // Use left because IE does not support x.

        const position = $el.position();
        const parentPosition = $el.parent().position();
        const y = parentPosition.top + position.top;

        const xCenter = (x + bbox.width / 2) / <number>this.holder.width() * 100;
        const yCenter = (y + bbox.height / 2) / <number>this.find('scene').height() * 100;

        obj.bbox = bbox;
        obj.xCenter = xCenter;
        obj.yCenter = yCenter;
    }

    addIncomeBubbles() {
        /**
         * Add income bubbles for beat 3.
         */
        // 12.000€
        this.addIncomeBubble({
            holder: 'buildings-right',
            cls: `income-bubble-${BEATS.BEAT_3}`,
            amount: 12000,
            left: 6.8,
            top: 84,
            scale: 0.9
        });

        // 37.500€
        this.addIncomeBubble({
            holder: 'buildings-right',
            cls: `income-bubble-${BEATS.BEAT_3}`,
            amount: 37500,
            left: 18.45,
            top: 72,
            scale: 0.9
        });

        // 25.000€
        this.addIncomeBubble({
            holder: 'buildings-right',
            cls: `income-bubble-${BEATS.BEAT_3}`,
            amount: 25000,
            left: 30.1,
            top: 82,
            scale: 0.9
        });

        // 51.000€
        this.addIncomeBubble({
            holder: 'buildings-right',
            cls: `income-bubble-${BEATS.BEAT_3}`,
            amount: 51000,
            left: 41,
            top: 63,
            scale: 0.9
        });

        // 22.000€
        this.addIncomeBubble({
            holder: 'buildings-right',
            cls: `income-bubble-${BEATS.BEAT_3}`,
            amount: 22000,
            left: 48.1,
            top: 80,
            scale: 0.9
        });

        // 43.000€
        this.addIncomeBubble({
            holder: 'buildings-right',
            cls: `income-bubble-${BEATS.BEAT_3}`,
            amount: 43000,
            left: 61.75,
            top: 72,
            scale: 0.9
        });

        // 18.000€
        this.addIncomeBubble({
            holder: 'buildings-right',
            cls: `income-bubble-${BEATS.BEAT_3}`,
            amount: 18000,
            left: 73.4,
            top: 82,
            scale: 0.9
        });

        // 32.000€
        this.addIncomeBubble({
            holder: 'buildings-right',
            cls: `income-bubble-${BEATS.BEAT_3}`,
            amount: 32000,
            left: 85.3,
            top: 73,
            scale: 0.9
        });

        // 65.000€
        this.addIncomeBubble({
            holder: 'buildings-right',
            cls: `income-bubble-${BEATS.BEAT_3}`,
            amount: 65000,
            left: 5.5,
            top: 56,
            scale: 0.9
        });

        // 110.000€
        this.addIncomeBubble({
            holder: 'buildings-right',
            cls: `income-bubble-${BEATS.BEAT_3}`,
            amount: 110000,
            left: 45,
            top: 48,
            scale: 0.9
        });

        // Median income.
        this.addIncomeBubble({
            holder: 'buildings-right',
            cls: `income-bubble-${BEATS.BEAT_3}`,
            amount: this.averageIncome,
            left: 21,
            top: 48,
            scale: 1.5
        });

        /**
         * Income bubble beat 4.
         */
        this.addIncomeBubble({
            holder: 'buildings-right',
            cls: `income-bubble-${BEATS.BEAT_4}`,
            amount: 500000,
            left: 11,
            top: 15,
            scale: 1.5
        });
    }

    addIncomeBubble({holder = 'scene', cls = '', amount = 12000, left = 50, top = 50, scale = 1} = {}): void {
        const p = this.projectPrefix;

        const formattedNumber = this.numberFormatter.default(amount);
        const styles = [
            `left: ${left}%`,
            `top: ${top}%`,
            `transition-delay: ${this.getRandomNumber(200, 600)}ms`,
            /* The extra 50% comes from the height of the arrow. */
            `transform: translate(-50%, -150%) scale(${scale});`
        ];

        const html = `
            <div class="${p}-income-bubble ${p}-${cls}" style="${styles.join(';')}">
                <div>${formattedNumber}€</div>
                <img class="${p}-income-bubble-arrow" src="${arrowBubble}" />
            </div>
        `;

        this.find(holder).append(html);
    }

    refreshMarkerBboxCache() {
        for (let i in this.markers) {
            this.calculateMarkerCoordData(this.markers[i]);
        }
    }



    // Overriding this so the resize does not fire.
    // have to remove from framework.
    showCMSContent(): void {

    }

    getLoaderCircleHtml(): string {
        return `
            <div class="add-ds-loader">
                <div>
                    <img src="${akLogoTransp}"/>
                </div>
                <div class="add-ds-loader-circles">
                    <div class="loader-circle loader-circle-1"></div>
                    <div class="loader-circle loader-circle-2"></div>
                    <div class="loader-circle loader-circle-3"></div>
                </div>
            </div>
        `;
    }
}
